import { useState, useEffect } from 'react';
import { captureCustomEvent } from '../../utils/posthogUtils';

interface CommunityFiltersProps {
  onFiltersChange: (filters: CommunityFilterState) => void;
  myCommunitiesActive?: boolean;
}

export interface CommunityFilterState {
  search: string;
  myCommunities?: boolean;
}

export const CommunityFilters: React.FC<CommunityFiltersProps> = ({ onFiltersChange, myCommunitiesActive }) => {
  const [myCommunities, setMyCommunities] = useState(!!myCommunitiesActive);

  useEffect(() => {
    setMyCommunities(!!myCommunitiesActive);
  }, [myCommunitiesActive]);

  const handleMyCommunitiesToggle = () => {
    const next = !myCommunities;
    setMyCommunities(next);
    
    captureCustomEvent('community_filter_toggle', {
      eventProperties: {
        filter_type: 'my_communities',
        new_state: next
      }
    });
    
    onFiltersChange({ search: '', myCommunities: next });
  };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        className={`px-3 py-1.5 rounded-full text-sm border transition-colors flex items-center gap-2 focus:outline-none ${
          myCommunities
            ? 'bg-blue-600 text-white border-blue-600'
            : 'bg-white text-gray-900 border-gray-300 hover:border-gray-400'
        }`}
        onClick={handleMyCommunitiesToggle}
      >
        My Communities
      </button>
    </div>
  );
};